import { useEffect } from 'react';

export interface UseElementsCallbackOptions<T extends Element> {
  forwardRef: React.RefObject<HTMLElement>;
  selectors: string[];
  onElement: (element: T) => void | (() => void);
  deps?: React.DependencyList;
}

export const useElementsCallback = <T extends Element>(options: UseElementsCallbackOptions<T>) => {
  const { forwardRef, selectors, onElement, deps = [] } = options;

  useEffect(() => {
    const cleanups: Array<() => void> = [];

    selectors.forEach((selector) => {
      forwardRef.current?.querySelectorAll<T>(selector).forEach((element) => {
        const cleanup = onElement(element);

        if (cleanup) {
          cleanups.push(cleanup);
        }
      });
    });

    return () => {
      cleanups.forEach((cleanup) => cleanup());
    };
  }, [forwardRef, selectors, onElement, ...deps]);
};
